"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n\tmutation AddUserSearchQuery($clickId: Int, $query: String) {\n\t\taddUserSearchQuery(clickId: $clickId, query: $query) {\n\t\t\tsuccess\n\t\t\tstatus\n\t\t\tmessage\n\t\t}\n\t}\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ADD_QUERY_INSIGHT = (0, _graphqlTag.default)(_templateObject());
var _default = ADD_QUERY_INSIGHT;
exports.default = _default;

//# sourceMappingURL=ADD_QUERY_INSIGHT.js.map